import { Link } from "react-router-dom";
import { Footer, KonsildentLogo } from "../components/Brand";

export default function Legal({ title, text = "[Text folgt]" }: { title: string; text?: string }) {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-border bg-surface">
        <div className="mx-auto max-w-3xl px-4 py-3"><Link to="/login" aria-label="Konsildent"><KonsildentLogo className="h-9" /></Link></div>
      </header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-8">
        <div className="kd-card p-6">
          <h1 className="mb-4" data-testid="legal-title">{title}</h1>
          <p data-testid="legal-text">{text}</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
